import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "../../axios/axios";
import StaffForm from "./StaffForm";
import PageHeader from "../../components/PageHeader";
// import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import { Box, Toolbar, Typography, InputAdornment } from "@mui/material";

import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";

import { Dialog, Paper, Table, TableBody, TableCell, TableRow } from "@mui/material";
import * as StaffServices from "../../helper/StaffServices";

import Divider from "@mui/material/Divider";
import DataGrid from "../../components/useDataGrid";
import Popup from "../../components/Popup";
import Controls from "../../components/Controls";
import ConfirmDialog from "../../components/ConfirmDialog";
import Notification from "../../components/Notification";
import { Stack } from "@mui/system";
import { MyUseForm, MyForm } from "../../components/useForm";
import { useGlobalContext } from "../../context/Context";

import * as GenServices from "../../helper/GenServices";

// const initialValuesOld = {
//   //_id: "",
//   hid: "2",
//   staffId: "",
//   name: "",
//   soDo: "S/o.",
//   fhName: "",
//   gender: "",
//   unitName: "",
//   deptt: "",
//   desig: "",
//   remarks: "",
// };

const initialValues = {
  // staffId:"E104",
  _id: "",
  name: "",
  staffId: "",
  staffUN: "",
  ip: "",
  roles: { staffUN: "", ip: "", date: null, role: [] },
};

export default function StaffRoles() {
  const [hid] = useState(2);
  const { staffUN, ip, isEditRight, isDeleteRight } = useGlobalContext();

  // const [viewValues, setViewValues] = useState(initialValuesOld);
  const [records, setRecords] = useState([]);
  const [roles, setRoles] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = React.useState(false);
  const [selectedValue, setSelectedValue] = useState({});

  const [notify, setNotify] = useState({ isOpen: false, message: "", type: "" });

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isConfirm: null,
    title: "title",
    subtitle: "subtitle",
  });

  const validate = (fieldValues = formData) => {
    let temp = { ...errors };
    if (formData._id) {
      // console.log("fieldValues =====>", fieldValues.dob);
      // if ("name" in fieldValues) temp.name = fieldValues.name ? "" : "Name is required.";
      // if ("mobileNo" in fieldValues) {
      //   if ("pMobNo" in fieldValues.mobileNo) {
      //     // console.log("pMobNo =====>",fieldValues );
      //     temp.pMobNo = fieldValues.mobileNo.pMobNo.length == 10 ? "" : "Enter Correct Mobile No.";
      //   }
      // }
    }

    setErrors({
      ...temp,
    });

    // console.log("temp===>", temp);

    if ((fieldValues = formData)) return Object.values(temp).every((x) => x == "");
  };

  const { formData, setFormData, errors, setErrors, handleChange } = MyUseForm(initialValues, true, validate);

  const getStaffRoles = () => {
    setRoles(GenServices.getAuthRoles());
  };

  const getStaffRecord = async () => {
    //setLoading(true);
    // validate(initialValues);
    try {
      const res = await axios.get(`/staff/?hid=${hid}`);
      //  console.log("getStaffRecord  ===>", res);

      if (res) {
        // console.log("res.data ===>", res.data)
        const staffRecord = res.data.filter((row) => {
          return row.isOfficeStaff == true;
        });
        setRecords(staffRecord);
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
    //setLoading(false);
  };

  useEffect(() => {
    getStaffRoles();
    getStaffRecord();
  }, []);

  // const handleClickOpen = () => {
  //   setOpenPopup(true);
  // };

  // const handleClose = (value) => {
  //   setOpenPopup(false);
  //   setSelectedValue(value);
  // };

  useEffect(() => {
    if (formData != null) {
      // console.log("useEffect formData  ===>", formData);

      setFormData((preValues) => {
        return { ...preValues, roles: { ...preValues.roles, staffUN: staffUN } };
      });

      setFormData((preValues) => {
        return { ...preValues, roles: { ...preValues.roles, ip: ip } };
      });

      setFormData((preValues) => {
        return { ...preValues, roles: { ...preValues.roles, date: dayjs() } };
      });

      setFormData((preValues) => {
        return { ...preValues, roles: { ...preValues.roles, role: formData.roles.role } };
      });
    }
  }, [formData.roles.role]);

  const bindData = () => {
    setFormData(initialValues);
    getStaffRecord();
  };

  const updateData = async () => {
    // const Staff = {...viewValues};
    // console.log("opdData updateData =========>", opdData);
    // const queryobj = { params: { mrNo: 1234 } }; //<=== this query only for testing
    if (formData._id) {
      //This is for Update
      // RegnServices.updatePatient(Staff);
      try {
        if (isEditRight) {
          const res = await axios.patch(`/staff/${formData._id}`, formData);
          // console.log("axios.patch response===>", res);
          if (res) {
            bindData();
            setNotify({ isOpen: true, message: "Updated Successfully", type: "success" });
            setOpenPopup(false);
          }
        } else {
          setNotify({
            isOpen: true,
            message: "You do not have rights to add Roles. Please contact the Administrator.!",
            type: "error",
          });
        }
      } catch (error) {
        console.error("error=====>", error);
        setNotify({ isOpen: true, message: error.message, type: "error" });
      }
    }
  };

  const onDelete = async (data) => {
    try {
      // console.log("onDelete _id =====>", data);

      if (data._id) {
        setConfirmDialog({ ...confirmDialog, isOpen: false });

        // console.log("viewValues._id ===>", viewValues._id);
        // const res = await axios.patch(`/staff/updatepassword/${viewValues._id}`, formData);
        if (isDeleteRight) {
          // const res = await axios.patch(`/staff/deleteUserRoles/${data._id}`, data);
          const res = await axios.patch(`/staff/${data._id}`, data);
          if (res) {
            bindData();
            setNotify({ isOpen: true, message: `Deleted Successfully`, type: "success" });
            //setOpenPopup(false);
          }
        } else {
          setNotify({
            isOpen: true,
            message: "You do not have rights to delete. Please contact the Administrator.!",
            type: "error",
          });
        }
      } else {
        setNotify({
          isOpen: true,
          message: "Data not found!",
          type: "error",
        });
      }

      // updateData('Deleted')
    } catch (error) {
      console.error("error=====>", error);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
  };

  const handleClickDelete = (data) => {
    if (isDeleteRight) {
      const deleteData = {
        _id: data._id,
        roles:{staffUN:"",ip: "", date:null, role:[] },
        staffUN: staffUN,
        ip: ip,
      };
      setConfirmDialog({
        isOpen: true,
        title: "Are you sure to delete the Staff-Roles?",
        subtitle: "You can't undo this operation",
        isConfirm: () => {
          onDelete(deleteData);
        },
      });
    } else {
      setNotify({ isOpen: true, message: "you do not have the right to delete", type: "error" });
    }
  };

  const showInEdit = (data) => {
    // console.log("showInEdit ====>", data);
    setFormData(data);
    // setFormData()

    setFormData((preValues) => {
      return { ...preValues, roles: { ...preValues.roles, role: data.roles.role } };
    });

    setFormData((preValues) => {
      return { ...preValues, staffUN: staffUN };
    });
    setFormData((preValues) => {
      return { ...preValues, ip: ip };
    });
    // alert("showInEdit start aaaaaaaaaaaaa");
    setOpenPopup(true);
    // console.log("showInEdit setFormData ====>", data);
  };

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (curObj) => {
        return (
          <>
            <Stack direction="row" spacing={1}>
              {curObj.row.roles.role.length > 0 && (
                <>
                  <Controls.ActionButton color="primary" title="Edit" onClick={() => showInEdit(curObj.row)}>
                    <ModeEditOutlineIcon />
                  </Controls.ActionButton>
                  <Controls.ActionButton color="red" title="Delete" onClick={() => handleClickDelete(curObj.row)}>
                    <CloseIcon />
                  </Controls.ActionButton>
                </>
              )}

              {!curObj.row.roles.role.length > 0 && (
                <Controls.ActionButton color="" variant="outlined" title="Add" onClick={() => showInEdit(curObj.row)}>
                  <AddIcon />
                </Controls.ActionButton>
              )}
            </Stack>
          </>
        );
      },
    },
    { field: "staffId", headerName: "StaffID", width: 90 },
    { field: "name", headerName: "Full name", width: 150, editable: true },
    { field: "fhName", headerName: "F/H Name", width: 150 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "deptt", headerName: "Department", width: 150 },
    { field: "desig", headerName: "Designation", width: 150 },
    { field: "banned", headerName: "Banned", width: 80 },
    { field: "roles", headerName: "Roles", width: 250, valueGetter: (item) => item.row.roles.role },
    // { field: "roles", headerName: "Roles", width: 250, renderCell: (item) => 
    //   (<span  sx={{ fontSize: 12 }}>
    //   {item.row.roles.role }
    // </span>) },   
  ];

  //useForm ******************************************** */

  const handleSubmit = () => {
    //e.preventDefault();
    if (formData._id) {
      if (validate()) {
        // console.log("updateData ===>", formData);
        updateData();
      } else {
        setNotify({ isOpen: true, message: "Please enter the value in required fields!", type: "error" });
        //  console.log(errors)
      }
    } else {
      setNotify({ isOpen: true, message: "Please select the Staff's record!", type: "error" });
      //  console.log(errors)
    }
  };

  // const resetForm = () => {
  //   setNotify({ isOpen: false, message: "", type: "" });
  //   // setViewValues(initialValuesOld);
  //   setFormData(initialValues);
  //   setErrors({});
  // };

  return (
    <>
      <h2>Staff Roles</h2>
      {/* <PageHeader title="Staff Roles" subTitle="SubTitle here" icon={<PeopleOutlineRoundedIcon fontSize="large" color="primary" />} /> */}

      {/* <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end"></Box> */}

      <Popup title="Create Staff Roles" maxWidth="md" openPopup={openPopup} setOpenPopup={setOpenPopup}>
      {/* <MyForm onSubmit={handleSubmit}> */}
      <Grid container spacing={2}>
        {/* staffId */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Controls.Input
            label="Staff ID"
            name="staffId"
            value={formData.staffId}
            disabled
            // onChange={handleChangeStaffID}
            // title="press tab key for get record"
            // onKeyDown={(e) => (e.key === "Tab" ? getDataByStaffID() : "")}
            error={errors.mrNo}
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            //       <IconButton onClick={getDataByStaffID} color="primary" sx={{ p: "10px" }} aria-label="directions">
            //         <DirectionsIcon />
            //       </IconButton>
            //     </InputAdornment>
            //   ),
            // }}
          />
        </Grid>

        {/* Name */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Controls.Input
            label="Full Name"
            name="name"
            value={formData.name}
            // onChange={handleChange}
            error={errors.name}
          />
        </Grid>
        <Divider sx={{ width: "100%", height: 10, m: 0.5 }} orientation="horizontal" />
        {/* roles.role */}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controls.AutocompleteTag
            label="Roles"
            name="roles.role"
            value={formData.roles.role}
            onChange={handleChange}
            // options={GenServices.getCountryList().map((option) => option.label)}
            options={roles}
          />
        </Grid>
        {/* Button */}
        <Grid item xs={12} sm={12} md={12} lg={12} alignContent="center">
          <Controls.Button
            sx={{ mx: "10px" }}
            text="Save"
            //variant="outlined"
            onClick={handleSubmit}
            // type="submit"
            startIcon={<SaveRoundedIcon />}
          />
        </Grid>

        {/* <Grid item sm={12}>
          <FormControlLabel control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Grid> */}

        {/* <Grid item sm={12} md={3}>
          <FormGroup row>  
            
            <TextField label="Test-Name" variant="standard" placeholder="username" />
            </FormGroup>
        </Grid> */}
      </Grid>
      {/* </MyForm> */}
      </Popup>

      <Notification notify={notify} setNotify={setNotify} /> 

      <DataGrid heading="" columns={columns} rows={records} pageSize={50} boxHeight={800} /> 

      <Notification notify={notify} setNotify={setNotify} />

      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      <div>
        Note
        <ul>
          <li>Only ADMIN user can edit or delete records </li>
        </ul>
      </div>
    </>
  );
}
